export function cssFontFaceSrc(name, weight = 400) {
  for (const stylesheet of document.styleSheets) {
    let rules;

    try {
      rules = stylesheet.cssRules;
    } catch {
      continue;
    }

    if (!rules) continue;

    for (const rule of rules) {
      if (
        rule instanceof CSSFontFaceRule
        && name === rule.style.getPropertyValue('font-family').replace(/['"]/g, '')
        && weight === rule.style.getPropertyValue('font-weight')
      ) {
        return rule.style.getPropertyValue('src').match(/url\(['"]?(.*?)['"]?\)/)[1];
      }
    }
  }

  return null;
}

export function cssVar(name, element = document.documentElement) {
  return getComputedStyle(element).getPropertyValue(name);
}

export function cssVars(element = document.documentElement) {
  const variables = {};
  const styles = getComputedStyle(element);

  for (let i = 0; i < styles.length; i++) {
    const prop = styles[i];
    if (prop.startsWith('--')) {
      variables[prop] = styles.getPropertyValue(prop);
    }
  }

  return variables;
}

